import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { storage } from "utils/storage";
import { useNavigate } from "react-router-dom";
import { EnumeratorLoginPayloadInterface } from "./dto";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../../firebase/firebase.js";
import { query, where, collection, getDocs } from "firebase/firestore";
import { RoleTypes } from "enum/role-type-enum";

export const loginEnumerator = async (
  data: EnumeratorLoginPayloadInterface
): Promise<{ data: any; token: string } | null> => {

  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      data.emailOrPhone,
      data.password
    );

    const user = userCredential.user;
    const token = await user.getIdToken();
    const userInfoQuery = query(collection(db, "user_infos"), where("uid", "==", user.uid));
    const userDocSnap = await getDocs(userInfoQuery);

    let existingUserInfo = null;
    if (!userDocSnap.empty) {
      existingUserInfo = userDocSnap.docs[0].data();
      if (
        !existingUserInfo.role ||
        existingUserInfo.role.toLowerCase() !== RoleTypes.ENUMERATOR.toLowerCase()
      ) {
        throw new Error(
          `Login Error: Your registered role (${existingUserInfo.role}) does not match the login method.`
        );
      }

      storage.setUserInStorage(existingUserInfo);
      storage.setTokenInStorage(token);
      return { data: existingUserInfo, token };
    } else {
      throw new Error("Login Error: User not found.");
    }
  } catch (error) {
    return Promise.reject(
      new Error(
        "Invalid Email or password."
      )
    );
  }
};

export const useLoginEnumerator = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: loginEnumerator,
    onSuccess: async (response) => {
      if (response) {
        const { data, token } = response;
        storage.setUserInStorage(data);
        storage.setTokenInStorage(token);
        await queryClient.invalidateQueries({ queryKey: ["enumerator"] });
        notification.success({
          message: "Logged In",
          description: "You have successfully logged in.",
        });
        navigate("/enumerator/home");
      }
    },
  });
};